import type { ComposeViewState } from 'owa-mail-compose-store';
import type AccCheckerViewState from 'owa-editor-acc-checker/lib/store/schema/AccCheckerViewState';
import { getMainWindowComposeViewState } from 'owa-mail-compose-actions/lib/selectors/getMainWindowComposeViewState';

export const getAccCheckerState = (
    viewState: ComposeViewState
): AccCheckerViewState | undefined => {
    const state = viewState ?? getMainWindowComposeViewState();
    if (state) {
        return state.accChecker;
    }
    return undefined;
};
